import { API_ENDPOINT } from '../../resources/@types/apiEndpoint';
import { useClientApiV1UsersUserIdIsFollowingQuery } from '../../resources/@types/uccSchema';

export default function useCheckFollowing(id: string) {
  const result = useClientApiV1UsersUserIdIsFollowingQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_USERS_USERID_IS_FOLLOWING(id)],
    url: API_ENDPOINT.CLIENT_V1_USERS_USERID_IS_FOLLOWING(id),
    options: {
      enabled: Boolean(id),
    },
  });

  return {
    ...result,
    data: result.data,
  };
}
